// extracted by css-extract-rspack-plugin
export default {"DocumentsTabContent":"sputnik__DocumentsTabContent__hNsXz","documentsTabContent":"sputnik__DocumentsTabContent__hNsXz"};